import {VisualComponent} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/VisualComponent';
import {FlowBlock} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {CloudComponent} from '@mintdata-wsp/common/state/ui/visualDesigner/VisualDesignerState';
import {WSPIcon} from '@mintdata-wsp/resources/icons/WSPIcon';
import {WSPIconName, WSPIconSize} from '@mintdata-wsp/resources/icons/WSPIcons';
import {FlowIconsMap} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowIconsMap';
import {SurfaceIconsMap} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/surface/SurfaceIconsMap';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import bind from 'bind-decorator';

export class ComponentIconsController
{
    @bind
    public getIconForVisualComponent(vc:VisualComponent, size = WSPIconSize.medium, className:any = null):React.ReactElement<any>
    {
        return this._getForVisualComponent(vc, size, className);
    }

    @bind
    public getForCloudComponent(c:CloudComponent, size = WSPIconSize.medium, className:any = null):React.ReactElement<any>
    {
        return this._getForCloudComponent(c, size, className);
    }

    @bind
    public getIconForBlock(block:FlowBlock, size = WSPIconSize.medium, className:any = null):React.ReactElement<any>
    {
        if( block.isVisualLink )
        {
            const boxId = block.visualLink.boxId;
            const box = boxId ? controllers.ui.openDesign.findBoxFromId(boxId) : null;

            if( box )
            {
                const vc:VisualComponent = box.component;
                return this._getForVisualComponent(vc, size, className);
            }
            else
                return WSPIcon.for(SurfaceIconsMap.DEFAULT_ICON, size, className);
        }
        else
        {
            return this._getForCloudComponent(block.component, size, className);
        }
    }

    private _getForCloudComponent(c:CloudComponent, size:WSPIconSize, className:any)
    {
        const iconName = this._resolveCloudIconName(c);
        return WSPIcon.for(iconName, size, className);
    }

    private _getForVisualComponent(vc:VisualComponent, size:WSPIconSize, className:any):React.ReactElement<any>
    {
        const iconName = this._resolveVisualIconName(vc);
        return WSPIcon.for(iconName, size, className);
    }

    @bind
    private _resolveVisualIconName(vc:VisualComponent):WSPIconName
    {
        const bundleId = vc.visualArtifactRef.id.toLowerCase();
        const nameToIconName = SurfaceIconsMap.BundleIdToIconsMap[bundleId];

        if( !nameToIconName )
            return SurfaceIconsMap.DEFAULT_ICON;

        const iconName = nameToIconName[vc.name.toLowerCase()];

        if( !iconName )
            return SurfaceIconsMap.DEFAULT_ICON;

        return iconName;
    }

    @bind
    private _resolveCloudIconName(c:CloudComponent):WSPIconName
    {
        const map = FlowIconsMap.ArtifactToIconsMap;
        const mavenTriple = c.group.id;

        const artifactIcons = map[mavenTriple];
        if( !artifactIcons )
            return FlowIconsMap.DEFAULT_ICON;

        const javaClassNameParts = c.javaClassFQN.split('.');
        const javaLastPart = javaClassNameParts && javaClassNameParts.length > 0 ?
            javaClassNameParts[javaClassNameParts.length - 1] : null;

        if( !javaLastPart )
            return FlowIconsMap.DEFAULT_ICON;

        const specificIcon = artifactIcons[javaLastPart];

        if( !specificIcon )
            return FlowIconsMap.DEFAULT_ICON;

        return specificIcon;
    }
}
